<template>
	<div>
		<el-dialog title="标记备注" :visible.sync="showDialog" width="480px" center append-to-body @close="cancel">
			<div class="opts_wrap" v-loading="loading">
				<div class="opts_line">
					<p class="txt">
						<span class="label">订单标记：</span>
						<span class="val">
							<el-radio-group v-model="formTagColor">
								<el-radio :label="c.val" v-for="c in colors" :key="c.val">
									<i class="el-icon-s-flag" :style="{ color: c.color }"></i>
									<span class="color_text">{{ c.text }}</span>
								</el-radio>
							</el-radio-group>
						</span>
					</p>
				</div>
				<div class="opts_line">
					<p class="txt">
						<span class="label">订单备注：</span>
						<span class="val">
							<el-input
								type="textarea"
								:rows="5"
								placeholder="请输入订单备注信息，此备注信息不对用户展示；可留空清空"
								v-model="formNotes"
								maxlength="512"
								show-word-limit
							></el-input>
						</span>
					</p>
				</div>
				<div class="btn_wrap">
					<p class="btn primary" @click="saveBtn">修改</p>
					<p class="btn" @click="cancel">关闭</p>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapActions } from 'vuex'

const DEFAULT_COLORS = [
	{ val: 0, text: '灰色', color: '#909399' },
	{ val: 1, text: '红色', color: '#F56C6C' },
	{ val: 2, text: '橙色', color: '#E6A23C' },
	{ val: 3, text: '绿色', color: '#67C23A' },
	{ val: 4, text: '蓝色', color: '#409EFF' },
]

export default {
	name: 'MerchantNotesDialog',
	props: {
		show: { type: Boolean, default: false },
		orderId: { type: Number, default: 0 },
		shopId: { type: String, default: '' },
		wxOrderId: { type: String, default: '' },
		initNotes: { type: String, default: '' },
		initTagColor: { type: [Number, String], default: 0 },
		tagColors: { type: Array, default: () => [] },
	},
	data() {
		return {
			showDialog: false,
			loading: false,
			formNotes: '',
			formTagColor: 0,
		}
	},
	computed: {
		colors() {
			return (this.tagColors && this.tagColors.length) ? this.tagColors : DEFAULT_COLORS
		},
	},
	watch: {
		show(val) {
			if (val) {
				this.formNotes = this.initNotes || ''
				const c = this.initTagColor
				this.formTagColor = (c === null || c === '' || c === undefined) ? 0 : Number(c)
				this.showDialog = true
			} else {
				this.showDialog = false
			}
		},
	},
	methods: {
		...mapActions('wxshopOrder', ['postMerchantNotesAction']),
		saveBtn() {
			if (!this.orderId && !this.wxOrderId) {
				this.$message.error('订单参数缺失')
				return
			}
			this.loading = true
			const data = {
				merchant_notes: this.formNotes == null ? '' : String(this.formNotes),
				merchant_notes_tag_color: Number(this.formTagColor),
			}
			if (this.orderId) data.id = this.orderId
			if (this.wxOrderId) data.wx_order_id = this.wxOrderId
			if (this.shopId) data.shop_id = this.shopId

			this.postMerchantNotesAction({
				data,
				success: (res) => {
					this.loading = false
					if (res.code === 200) {
						this.$message.success(res.message || res.msg || '备注已更新')
						this.$emit('complete', res.data || {})
						this.cancel()
					} else {
						this.$message.error(res.message || res.msg || '修改失败')
					}
				},
				error: (err) => {
					this.loading = false
					this.$message.error((err && (err.message || err.msg)) || '修改失败')
				},
			})
		},
		cancel() {
			this.showDialog = false
			this.$emit('close')
		},
	},
}
</script>

<style scoped>
.opts_wrap { padding-top: 8px; }
.opts_line { margin-top: 16px; }
.opts_line .txt { display: flex; font-size: 14px; line-height: 24px; }
.opts_line .label { min-width: 80px; color: #666; }
.opts_line .val { flex: 1; }
.opts_line .color_text { margin-left: 4px; font-size: 12px; color: #666; }
.btn_wrap { margin: 28px auto 0; display: flex; justify-content: center; }
.btn_wrap .btn {
	width: 80px; height: 34px; border-radius: 4px; display: flex; justify-content: center;
	align-items: center; cursor: pointer; box-sizing: border-box; font-size: 14px;
	background: #fff; color: #333; border: 1px solid #ddd; margin: 0 7px;
}
.btn_wrap .btn.primary { background: #f0413e; color: #fff; border-color: #f0413e; }
</style>
